import React from "react";
import { Link } from "react-router-dom";

const ContentBody = (props) => {
  const { title, faqListData } = props;
  const faqList = faqListData || [];

  const displayFaqList = faqList.map((val) => {
    return (
      <React.Fragment key={Math.random(1, 9999)}>
        <tr>
          <td style={{ width: "400px" }}>{val.question}</td>
          <td>
            <div dangerouslySetInnerHTML={{ __html: val.answer }}></div>
          </td>
          <td className="text-center" style={{ width: "100px" }}>
            <div className="action-buttons d-flex justify-content-center">
              <Link
                className="btn btn-secondary light mr-2"
                to={`/admin/edit-faq/${val._id}`}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                  className="svg-main-icon"
                >
                  <g
                    stroke="none"
                    strokeWidth={1}
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x={0} y={0} width={24} height={24} />
                    <path
                      d="M8,17.9148182 L8,5.96685884 C8,5.56391781 8.16211443,5.17792052 8.44982609,4.89581508 L10.965708,2.42895648 C11.5426798,1.86322723 12.4640974,1.85620921 13.0496196,2.41308426 L15.5337377,4.77566479 C15.8314604,5.0588212 16,5.45170806 16,5.86258077 L16,17.9148182 C16,18.7432453 15.3284271,19.4148182 14.5,19.4148182 L9.5,19.4148182 C8.67157288,19.4148182 8,18.7432453 8,17.9148182 Z"
                      fill="#000000"
                      fillRule="nonzero"
                      transform="translate(12.000000, 10.707409) rotate(-135.000000) translate(-12.000000, -10.707409) "
                    ></path>
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x={5}
                      y={20}
                      width={15}
                      height={2}
                      rx={1}
                    />
                  </g>
                </svg>
              </Link>
            </div>
          </td>
        </tr>
      </React.Fragment>
    );
  });

  return (
    <React.Fragment>
      <div className="content-body">
        <div className="container-fluid">
          <div className="d-flex align-items-center mb-4 flex-wrap">
            <h4 className="fs-20 font-w600  me-auto">{title}</h4>
          </div>
          <div className="row">
            <div className="col-xl-12">
              <div className="table-responsive">
                <div
                  id="example_wrapper"
                  className="dataTables_wrapper d-flex justify-content-between"
                ></div>
                <table className="table display mb-4 dataTablesCard job-table table-responsive-xl card-table">
                  <thead>
                    <tr>
                      <th>Question</th>
                      <th>Answer</th>
                      <th className="text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody>{displayFaqList}</tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ContentBody;
